import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../accelerator-area.service';
import { AccDeliveryService } from '../../acc-delivery.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'acc-events-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './events-view.part.html',
})
export class AccEventsViewPart {

	private readonly util = inject(UtilityService);
	private readonly pageService = inject(AccDeliveryService);
	private readonly areaService = inject(AcceleratorAreaService);
	private readonly dialogService = inject(DialogService);

	public setup = getSetup(this.util, this.dialogService, this.areaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public events = computed(() => this.areaService.data()?.events ?? []);

}